function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { emptyObj } from '@beef/utils';
import { Device } from "../Device";
import style from "./styles.module.pcss";
import { Wrapper } from "./components/Wrapper";
var cn = classNames.bind(style);
var getBannersHash = function getBannersHash(banners) {
  var deviceBanners = banners !== null && banners !== void 0 ? banners : [];
  var bannersList = Array.isArray(deviceBanners) ? deviceBanners : [deviceBanners];
  var result = {};
  if (bannersList.length > 0) {
    var _iterator = _createForOfIteratorHelper(bannersList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var banner = _step.value;
        result[banner.index] = banner;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return result;
};
export var DeviceContainer = function DeviceContainer(_ref) {
  var className = _ref.className,
    children = _ref.children,
    caption = _ref.caption,
    _ref$captionTag = _ref.captionTag,
    captionTag = _ref$captionTag === void 0 ? 'p' : _ref$captionTag,
    banners = _ref.banners,
    _ref$isFetching = _ref.isFetching,
    isFetching = _ref$isFetching === void 0 ? false : _ref$isFetching,
    _ref$isLoadMore = _ref.isLoadMore,
    isLoadMore = _ref$isLoadMore === void 0 ? false : _ref$isLoadMore,
    isEmpty = _ref.isEmpty,
    nodeEmptyList = _ref.nodeEmptyList,
    previewCardsLength = _ref.previewCardsLength,
    _ref$rowsSpace = _ref.rowsSpace,
    rowsSpace = _ref$rowsSpace === void 0 ? 64 : _ref$rowsSpace,
    _ref$contentMaxWidth = _ref.contentMaxWidth,
    contentMaxWidth = _ref$contentMaxWidth === void 0 ? 237 : _ref$contentMaxWidth;
  var mappedChildren = useMemo(function () {
    if (!banners) {
      return children;
    }
    var bannersHash = getBannersHash(banners);
    var childrenList = React.Children.toArray(children);
    for (var i = 0; i < childrenList.length; i++) {
      var bannerIndex = i + 1;
      var bannerData = bannersHash[bannerIndex];
      if (bannerData) {
        var type = bannerData !== null && bannerData !== void 0 && bannerData.type ? bannerData.type : 'vertical';
        var banner = /*#__PURE__*/React.createElement("div", {
          className: cn("banner--".concat(type)),
          key: bannerIndex
        }, bannerData.banner);
        childrenList.splice(i, 0, banner);
      }
    }
    return childrenList;
  }, [banners, children]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    contentMaxWidth: contentMaxWidth,
    isEmpty: isEmpty,
    isFetching: isFetching,
    nodeEmptyList: nodeEmptyList,
    previewCardsLength: previewCardsLength,
    rowsSpace: rowsSpace
  }, /*#__PURE__*/React.createElement(React.Fragment, null, (caption === null || caption === void 0 ? void 0 : caption.length) && /*#__PURE__*/React.createElement("div", {
    className: cn('caption')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size2-m",
    tagType: captionTag
  }, caption)), /*#__PURE__*/React.createElement("div", {
    className: cn(className, 'wrapper', "wrapper--content-".concat(contentMaxWidth), "row--space-".concat(rowsSpace))
  }, mappedChildren, isLoadMore && /*#__PURE__*/React.createElement(React.Fragment, null, Array.from(Array(previewCardsLength).keys()).map(function (device) {
    return /*#__PURE__*/React.createElement(Device, {
      device: emptyObj,
      isFetching: true,
      key: device
    });
  })))));
};